<template>

  <div id="questionPaperPreview" class="" style="background-color: white;">
    <!-- header ----------------- -->
    <b-row class="">
      <b-col class="text-right">
       
        <span style="font-size: 35px !important; font-weight: 800;">{{ examSettings.slot_number }}</span>
      </b-col>
    </b-row>
    <b-row class="">
      <b-col>Register No. :...................................</b-col>
      <b-col class="text-right"> Name:........................................................</b-col>
    </b-row>
    <div class="customHeaderDiv mt-2" v-html="customHeader"></div>
    <div class="mb-3">
      <table style="width: 100%;">
        <tr>
          <td class="text-center">Time: {{ examSettings.questionPaperTime?examSettings.questionPaperTime:'_' }}
            Hrs.</td>
          <td class="text-center">{{ exam.name }}</td>
          
          <td class="text-center" v-if="examSettings.questionPaperDate != ''">Date: {{ examSettings.questionPaperDate }}</td>
          <td class="text-center">Maximum Marks: {{ examSettings.questionPaperMaximumMark }} </td>
        </tr>
      </table>
    </div>
    <!-- ------------------------------- -->
    <!-- questions --------------------- -->

    <div class="text-danger" v-if="loading"> Loading...</div>


    <h5 v-if="examSettings.enabledCoDescription && examSettings.coDescriptionPosition == 'above'" class="mt-2 common-font" >CO: Course Outcomes</h5>
    <ul v-if="examSettings.enabledCoDescription && examSettings.coDescriptionPosition == 'above'" class="common-font">
      <li v-for="(co, coId) in courseOutcomes" :key="coId">{{ co.code }}: {{ co.outcome }}</li>
    </ul>

    <h5 v-if="examSettings.enabledTaxonamyDescription && examSettings.taxonamyDescriptionPosition == 'above'" class="common-font">BL: Blooms Taxonomy Level</h5>
    <p v-if="examSettings.enabledTaxonamyDescription && examSettings.taxonamyDescriptionPosition == 'above'" class="common-font">
      <span v-for="(tx, coId) in bloomTaxonomyOptions" :key="coId" >{{ tx.value }}-{{ tx.text }},
        &nbsp;&nbsp;&nbsp;</span>
    </p>

    <table :style="{ zoom: zoomLevel }" class="common-font" v-if="!loading" :class="{ 'custom-table22': true, 'no-border-cell': examSettings.enableQuestionTableBorder }">
      <tr :class="{ 'no-border-cell': examSettings.enableQuestionTableBorder }">
        <th class="text-center">No.</th>
        <th class="pr-3 text-center">Question</th>
        <th class="px-3 text-center" v-if="examSettings.enabledHeadersMark">Mark</th>
        <th class="px-3 text-center" v-if="examSettings.enabledHeadersCo">CO</th>
        <th class="px-3 text-center" v-if="examSettings.enabledHeadersModule">ML</th>
        <th class="px-3 text-center" v-if="examSettings.enabledHeadersTaxonamy">BL</th>
        <th class="px-3 text-center" v-if="examSettings.enabledHeadersPo">PO</th>
        <th class="px-3 text-center" v-if="examSettings.enabledHeadersPso">PSO</th>
        <!-- <th v-for="header in enabledHeaders" :key="header">{{header}}</th> -->
      </tr>
      <tbody v-for="row in questionPaperTableData" :key="(row.type + '' + row.id)"
        :class="{ 'no-border-cell': examSettings.enableQuestionTableBorder }">
        <tr v-if="row.type == 'orGroup'" :class="{ 'no-border-cell': examSettings.enableQuestionTableBorder }">
          <td :colspan="row.colspan" class="custom-text-or-question mt-2 p-1 text-center font-weight-bold">{{ row.text }}</td>
        </tr>
        <tr v-if="row.type == 'orGroupQuestionSeparation'" :class="{ 'no-border-cell': examSettings.enableQuestionTableBorder }">
          <td  :colspan="row.colspan" class="custom-text-or-question text-center font-weight-bold">{{
            row.text
          }}</td>
        </tr>
        <tr v-if="row.type == 'section'" :class="{ 'no-border-cell': examSettings.enableQuestionTableBorder }">
          <td :colspan="row.colspan" class="custom-text-section mt-4 p-1 text-center font-weight-bold">{{ row.text }}</td>
        </tr>
        <tr style="page-break-inside:auto;" v-if="row.type == 'question'" :class="{ 'no-border-cell': examSettings.enableQuestionTableBorder }">
          <td>{{ row.q_no }}</td>
          <td :colspan="row.colspan != null ? row.colspan : ''">
            <span v-for="(qData, qdIndex) in row.question" :key="qdIndex" class="mr-1">
              <span class="big-font" v-if="qData.type == 'text'" v-html="latexCodeToMathLive(qData.value)"></span>
              <math-field v-if="qData.type == 'equation'" class="p-0" style="border: none;" readonly>{{
            qData.value
          }}</math-field>
              <img
                class="questionPaperPreviewImg"
                v-if="qData.type === 'image' && questionAttachments[qData.value] && questionAttachments[qData.value].url"
                :src="questionAttachments[qData.value].url"
              >
            </span>
          </td>
          <td class="text-center big-font" v-if="(row.colspan == null && examSettings.enabledHeadersMark)">{{ row.mark }}</td>
          <td class="text-center" v-if="row.colspan == null && examSettings.enabledHeadersCo">
            <span v-if="displayOnlyNumeralCo">{{ extractNumerals(row.co) }}</span>
            <span v-else>{{ row.co }}</span>
          </td>
          <td class="text-center" v-if="row.colspan == null && examSettings.enabledHeadersModule">
            <span v-if="displayOnlyNumeralMl">{{ extractNumerals(row.module) }}</span>
            <span v-else>{{ row.module }}</span>
          </td>
          <td class="text-center" v-if="row.colspan == null && examSettings.enabledHeadersTaxonamy">{{ row.taxonamy }}</td>
          <td class="text-center" v-if="row.colspan == null && examSettings.enabledHeadersPo">
            <span v-if="displayOnlyNumeralPo">{{ extractNumerals(row.po) }}</span>
            <span v-else>{{ row.po }}</span>
          </td>
          <td class="text-center" v-if="row.colspan == null && examSettings.enabledHeadersPso">
            <span v-if="displayOnlyNumeralPso">{{ extractNumerals(row.pso) }}</span>
            <span v-else>{{ row.pso }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- ------------------------------- -->
    <!-- ---------footer  -->
    <h5 class="mt-5 common-font" :style="{ zoom: zoomLevel }" v-if="examSettings.footerQuestionPaperLevel">Question Paper Level: {{ taxonamyScoreProductSum }}/{{ taxonamyScoreSum
      }}={{ Math.round(taxonamyScoreProductSum / taxonamyScoreSum * 100) / 100 }}</h5>
    <h5 v-if="examSettings.enabledCoDescription && examSettings.coDescriptionPosition == 'below'" :style="{ zoom: zoomLevel }" class="mt-2 common-font" >CO: Course Outcomes</h5>
    <ul v-if="examSettings.enabledCoDescription && examSettings.coDescriptionPosition == 'below'" :style="{ zoom: zoomLevel }" class="common-font">
      <li v-for="(co, coId) in courseOutcomes" :key="coId">{{ co.code }}: {{ co.outcome }}</li>
    </ul>
    
    <h5 v-if="examSettings.enabledTaxonamyDescription && examSettings.taxonamyDescriptionPosition == 'below'" :style="{ zoom: zoomLevel }" class="common-font">BL: Blooms Taxonomy Level</h5>
    <p v-if="examSettings.enabledTaxonamyDescription && examSettings.taxonamyDescriptionPosition == 'below'" :style="{ zoom: zoomLevel }" class="common-font">
      <span v-for="(tx, coId) in bloomTaxonomyOptions" :key="coId" >{{ tx.value }}-{{ tx.text }},
        &nbsp;&nbsp;&nbsp;</span>
    </p>

    <h5 v-if="examSettings.enabledTaxonamyDistribution" :style="{ zoom: zoomLevel }" class="common-font">Display BL Distribution %</h5>
    <p v-if="examSettings.enabledTaxonamyDistribution" :style="{ zoom: zoomLevel }" class="common-font">
      <span v-for="(tx, coId) in bloomTaxonomyOptions" :key="coId" >{{ tx.value }}-{{ tx.text }} 
        <strong>{{ ((taxonamyScoreDistribution[tx.value] || 0) / (taxonamyScoreDistributionSum || 1) * 100).toFixed(1) }} %</strong>
        ,&nbsp;&nbsp;&nbsp;</span>
    </p>

    <h5 v-if="examSettings.enabledHeadersModule" class="common-font" :style="{ zoom: zoomLevel }"> ML: Module</h5>
    <table :class="{ 'custom-table22': true,}" class="mt-5 common-font" :style="{ zoom: zoomLevel }" v-if="examSettings.footerSignatureField">
      <thead>
        <template v-if="signatureFields && signatureFields.length > 0">
          <tr>
            <th v-for="(signField, sindex) in signatureFields[0].signed_officials" :key="sindex">
              {{ roleLabels[sindex] || '-' }}
              <span v-if="signatureFields[0].signed_officials[sindex]=='course_in_charge'"> Course-in-Charge</span> 
              <span v-else>{{ formatSignedOfficial(signatureFields[0].signed_officials[sindex]) }}</span>
              <br>
              
            </th>
          </tr>
          <tr>
            <td style="height: 70px;" v-for="(signedRole, sindex) in Object.keys(signatureFields[0].signed_officials)" :key="'td-' + sindex" class="p-2">
              <span v-if="signatureFields[0].signed_officials[signedRole].includes('course_in_charge')">
                {{ footerData.course_admin }}<br><br>
              </span> 
              <span v-if="signatureFields[0].signed_officials[signedRole].includes('HOD')">
                {{ footerData.maingroup_admin }}<br><br>
              </span> 
              <span v-if="signatureFields[0].signed_officials[signedRole].includes('advisor')">
                {{ footerData.subgroup_admin }}<br><br>
              </span>
            </td>
          </tr>
        </template>

        <template v-else>
          <tr>
            <th>Prepared By Course-in-Charge</th>
            <th>Verified By DQAC member</th>
            <th>Approved By HOD</th>
          </tr>
          <tr>
            <td style="height: 70px;" class="p-2">{{ footerData.course_admin }}</td>
            <td style="height: 70px;" class="p-2"></td>
            <td style="height: 70px;" class="p-2"></td>
          </tr>
        </template>
      </thead>
    </table>
    <span style="color:red"  class="no-print" v-if="examSettings.footerSignatureField && signatureFields.length !=0 && Object.keys(signatureFields[0].signed_officials).length == 0">
     <b>
      To add a signature field, contact the HOD.
     </b> 
    </span>
    <b-checkbox :style="{ zoom: zoomLevel }" class="common-font mr-5 no-print" disabled v-if="questionPaperLevelCalculationFailed">View Question Paper Level (<span style="color: red;"> Failed to calculate</span>)</b-checkbox>
   
    <!-- ---------------- -->
    <!-- graphs  ------------------------->
    <b-row class="mt-5 common-font" :style="{ zoom: zoomLevel }" v-if="examSettings.distributionGraphField">
      <b-col class="col-5 text-center">
        <span style="font-size: 6px; position: relative; text-decoration: underline;">
          CO Wise Marks Distribution
        </span>
        <Bar 
          :chart-data="coScoreDistributionChartData" 
          :chart-options="chartOptions" 
          style="width: 100%; height: 200px;" 
        />
      </b-col>
      <b-col class="col-2 text-center"></b-col>
      
      <b-col class="col-5 text-center">
        <span style="font-size: 6px; position: relative; text-decoration: underline;">
          BL Wise Marks Distribution
        </span>

        <Pie 
          :chart-data="taxonamyScoreDistributionChartData" 
          :chart-options="chartOptions1" 
          style="width: 100%; height: 170px;" 
        />
      </b-col>
    </b-row>

    <!-- -------------------------------- -->
  </div>
</template>

<script>

// to get in table format we need to loop in question order 
// and find out the enabled heading columns 
// and get the value of each column for each question 
// also the type of row wich is question/or group/ section 

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, ArcElement, CategoryScale, LinearScale)
import { Bar, Pie } from 'vue-chartjs/legacy'


import Vue from 'vue';
import * as MathLive from 'mathlive';
Vue.use(MathLive);
export default {
  props: {
    questionsAndGroupsAndSectionView: { type: Array, required: true },
    groupObjects: { type: Object, required: true },
    exam: { type: Object, required: true },
    sectionObjects: { type: Object, required: true },
    questionObjects: { type: Object, required: true },
    examSettings: { type: Object, required: true },
    zoomLevel: { type: Number, required: false },
  },
  async created() {
    this.loading = true;
    this.cloudStorageRoot = await this.$store.getters.getAPIKey.userAttachments;
    this.getQuestionPaperSignatureFieldSigningOfficials();
    await Promise.all([
      this.getDisplaySetting("co", "displayOnlyNumeralCo"),
      this.getDisplaySetting("po", "displayOnlyNumeralPo"),
      this.getDisplaySetting("pso", "displayOnlyNumeralPso"),
      this.getDisplaySetting("ml", "displayOnlyNumeralMl"),
    ]);
  },
  watch: {
    questionsAndGroupsAndSectionView: 'handlePropsLoaded',
    groupObjects: 'handlePropsLoaded',
    exam: 'handlePropsLoaded',
    sectionObjects: 'handlePropsLoaded',
  },
  async mounted() {
    this.handlePropsLoaded();
  },
  components: {
    Bar, Pie
  },
  data() {
    return {
       roleLabels: {
        'prepared_by': 'Prepared By',
        'verified_by': 'Verified By',
        'approved_by': 'Approved By'
      },
      displayOnlyNumeralCo: false,
      displayOnlyNumeralPo: false,
      displayOnlyNumeralPso: false,
      displayOnlyNumeralMl: false,
      subQuestionParentIds: [], 
      orGroupQuestionIds: {},
      orquestiongroups: {},
      enableQuestionTableBorder: true,
      questionPaperTableData: [],
      questionAttachments: {},//id:{id, url, name}
      courseOutcomes: {},
      bloomTaxonomyOptions: [
        {
          value: "6",
          text: "Creating",
          description: "User information to create something new",
        },
        {
          value: "5",
          text: "Evaluating",
          description: "Examine information and make judgement.",
        },
        {
          value: "4",
          text: "Analyzing",
          description: "Take apart from known and identify relationships.",
        },
        {
          value: "3",
          text: "Applying",
          description: "Use information in a new (but similar) situation.",
        },
        {
          value: "2",
          text: "Understanding",
          description: "Grasp meaning of instructional materials.",
        },
        {
          value: "1",
          text: "Remembering",
          description: "Recall specific facts.",
        },
      ],
      loading: true,
      cloudStorageRoot: '',
      courseModules: [],
      customHeader: null,
      footerData: { course_admin: '', maingroup_admin: '', subgroup_admin: '' },
      coScoreDistributionChartData: {
        labels: [], datasets: [{
          label: '', // Remove dataset label
          backgroundColor: '#334182',
          data: []
        }]
      },
      taxonamyScoreDistributionChartData: {
        labels: [],
        datasets: [
          {
            label: 'BL Wise Marks Distribution',
            backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16', '#7daa63', '#ffc107'],
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            onClick: null // Disables enable/disable feature in Bar chart
          }
        }
      },
      chartOptions1: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            onClick: null // Disables enable/disable feature in Bar chart
          }
        }
      },
      //Blooms Level Wise Marks Distribution
      taxonamyScoreSum: 0,
      taxonamyScoreProductSum: 0,
      questionPaperLevelCalculationFailed: false,
      signatureFields: [],
      taxonamyScoreDistribution: {},
      taxonamyScoreDistributionSum: 0,
      coScoreDistribution: {}
    };
  },
  methods: {
    extractNumerals(value) {
      if (!value) return '';
      // Match only digits and join them with commas
      return value.match(/\d+/g)?.join(', ') || '';
    },
    formatSignedOfficial(roles) {
      if (!roles) return ''; // Handle undefined or null cases
      return roles
        .filter(role => role) // Remove null values
        .map(role => this.capitalizeRole(role)) // Capitalize properly
        .join(', '); // Join with commas
    },
    capitalizeRole(role) {
      return role
        .split('_') // Split words by "_"
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' '); // Join them back with spaces
    },
    async getDisplaySetting(settingKey, stateProp) {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/setting/${this.exam.usergroup_id}/display_only_numeral_${settingKey}`;

      try {
        const response = await this.$axios.get(url);
        this[stateProp] = response.data && response.data == 1;
      } catch (e) {
        this[stateProp] = false; // default fallback
      }
    },
    getQuestionPaperSignatureFieldSigningOfficials() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/questionpapersignaturefield?usergroup_id=${this.exam.usergroup_id}`;
      this.$axios
        .get(url)
        .then((response) => {
          if (response.data) {
            // Filter out only the 'question_paper' field
            console.log("response.data",response.data);
            this.signatureFields = response.data
              .filter((field) => field.name === "question_paper")
              .map((field) => {
                let filteredOfficials = Object.keys(field.signed_officials).reduce((acc, key) => {
                  if (field.signed_officials[key].some((v) => v !== null)) {
                    acc[key] = field.signed_officials[key];
                  }
                  return acc;
                }, {});

                return { ...field, signed_officials: filteredOfficials };
              });
          }
        })
        .catch(() => { });
    },

    handlePropsLoaded() {
      if (
        this.questionsAndGroupsAndSectionView &&
        this.groupObjects &&
        this.exam &&
        this.sectionObjects
      ) {
        // All required props are loaded, call your function
        this.prepareTemplateData();
      }
    },
    
    async prepareTemplateData() {
      await Promise.all([
        this.getCourseModules(),
        this.ExamQuestionPaperCustomHeader(),
      ]);

      this.questionPaperTableData = await this.prepareQuestionPaperTableData();     
      // console.log(this.questionPaperTableData);

      this.loading = false;

      await MathLive.renderMathInDocument();

      for (const key in this.questionObjects) {
        const q = this.questionObjects[key];
        q.course_outcome.forEach(co => {
          this.courseOutcomes[co.id] = co;
        });
      }
      await this.getExamQuestionPaperFooter();
      this.prepareMarkDistributionGraph();
    },
    async prepareQuestionPaperTableData() {

      let questionsAndGroupsAndSectionView = await this.questionsAndGroupsAndSectionView;
      let groupObjects = await this.groupObjects;
      let questionObjects = await this.questionObjects;
      let sectionObjects = await this.sectionObjects;

      let questionPaperTableData = [];
      // this.enabledHeaders = {
      //   co: false, module: false, taxonamy: false, po: false, pso: false
      // }
       await Object.values(questionObjects).forEach(question => {
      //   if (question.blooms_taxonamy_level != null) this.enabledHeadersTaxonamy = true;
      //   if (question.module_id != null) this.enabledHeadersModule = true;
      //   if (question.course_outcome.length > 0) this.enabledHeadersCo = true;
      //   if (question.programme_outcome.length > 0) this.enabledHeadersPo = true;
      //  if (question.programme_specific_outcome.length > 0) this.enabledHeadersPso = true;
        question.files.forEach(file => {
          this.questionAttachments[file.id] = {
            id: file.id, name: file.file_name, url: this.cloudStorageRoot + file.file_path + file.file_name
          };
         });
       });
      let tempCustomHeaderCount = 0;
      if(this.examSettings.enabledHeadersMark) tempCustomHeaderCount++;
      if(this.examSettings.enabledHeadersCo) tempCustomHeaderCount++;
      if(this.examSettings.enabledHeadersModule) tempCustomHeaderCount++;
      if(this.examSettings.enabledHeadersTaxonamy) tempCustomHeaderCount++;
      if(this.examSettings.enabledHeadersPo) tempCustomHeaderCount++;
      if(this.examSettings.enabledHeadersPso) tempCustomHeaderCount++;

      let rowData = null;
      let taxonamyScoreProductSum = 0; // sum( taxonamy of q1 * score of q1 + ..q2...q3)
      let taxonamyScoreSum = 0; // sum of all question scores
      await questionsAndGroupsAndSectionView.forEach(ViewElement => {
        // console.log('-');
        if (ViewElement.type == 'group') {

          rowData = this.newRowDataSample();
          rowData.id = ViewElement.id;
          rowData.type = 'orGroup';
          rowData.colspan = tempCustomHeaderCount + 3;
          rowData.text = 'Answer ' + groupObjects[ViewElement.id].best_of_questions + ' out of ' + groupObjects[ViewElement.id].questions.length + ' questions';
          questionPaperTableData.push(rowData);

          let groupQuestionCount = groupObjects[ViewElement.id].questions.length;
          let groupQuestionCountIndex = groupQuestionCount;
          groupObjects[ViewElement.id].questions.forEach(question => {
            // console.log('--');
            rowData = this.newRowDataSample();
            rowData.id = question.id;
            rowData.type = 'question';
            rowData.q_no = question.question_no;
            rowData.question = question.question;
            if (question.subQuestions.length > 0) {
              rowData.colspan = tempCustomHeaderCount + 2;
            } else {
              rowData.mark = question.maximum_mark;
              rowData.co = question.course_outcome != null ? question.course_outcome.map(item => item.code).join(', ') : '';
              rowData.co_mapping = question.course_outcome.map(co => co.id),
              rowData.module = this.moduleName(question.module_id);
              rowData.taxonamy = question.blooms_taxonamy_level;
              rowData.po = question.programme_outcome != null ? question.programme_outcome.map(item => item.code).join(', ') : '';
              rowData.pso = question.programme_specific_outcome != null ? question.programme_specific_outcome.map(item => item.code).join(', ') : '';
              try {
                taxonamyScoreProductSum += Number(question.blooms_taxonamy_level) * Number(question.maximum_mark);
                taxonamyScoreSum += Number(question.maximum_mark);
              } catch (error) {
                this.questionPaperLevelCalculationFailed = true;
              }
            }
            questionPaperTableData.push(rowData);

            if (question.subQuestions.length > 0) {
              question.subQuestions.forEach(subQuestion => {
                // console.log('---');
                rowData = this.newRowDataSample();
                rowData.id = subQuestion.id;
                rowData.type = 'question';
                rowData.q_no = subQuestion.question_no;
                rowData.question = subQuestion.question;
                rowData.mark = subQuestion.maximum_mark;
                rowData.co = subQuestion.course_outcome != null ? subQuestion.course_outcome.map(item => item.code).join(', ') : '';
                rowData.co_mapping = subQuestion.course_outcome.map(co => co.id),
                rowData.module = this.moduleName(subQuestion.module_id);
                rowData.taxonamy = subQuestion.blooms_taxonamy_level;
                rowData.po = subQuestion.programme_outcome != null ? subQuestion.programme_outcome.map(item => item.code).join(', ') : '';
                rowData.pso = subQuestion.programme_specific_outcome != null ? subQuestion.programme_specific_outcome.map(item => item.code).join(', ') : '';
                questionPaperTableData.push(rowData);
                try {
                  taxonamyScoreProductSum += Number(subQuestion.blooms_taxonamy_level) * Number(subQuestion.maximum_mark);
                  taxonamyScoreSum += Number(subQuestion.maximum_mark);
                } catch (error) {
                  this.questionPaperLevelCalculationFailed = true;
                }
              });
            }

            if (groupQuestionCountIndex != 1) {
              rowData = this.newRowDataSample();
              rowData.id = Math.random().toString(36).substring(7);
              rowData.type = 'orGroupQuestionSeparation';
              rowData.colspan = tempCustomHeaderCount + 3;
              rowData.text = (groupQuestionCount == 2) ? 'OR' : '';  // separation text between or questions
              questionPaperTableData.push(rowData);
            }
            groupQuestionCountIndex--;

          });
        }
        if (ViewElement.type == 'question') {
          let question = questionObjects[ViewElement.id];
          rowData = this.newRowDataSample();
          rowData.id = ViewElement.id;
          rowData.type = 'question';
          rowData.q_no = question.question_no;
          rowData.question = question.question;
          if (question.subQuestions.length > 0) {
            rowData.colspan = tempCustomHeaderCount + 2;
          } else {
            rowData.mark = question.maximum_mark;
            rowData.co = question.course_outcome != null ? question.course_outcome.map(item => item.code).join(', ') : '';
            rowData.co_mapping = question.course_outcome.map(co => co.id),
            rowData.module = this.moduleName(question.module_id);
            rowData.taxonamy = question.blooms_taxonamy_level;
            rowData.po = question.programme_outcome != null ? question.programme_outcome.map(item => item.code).join(', ') : '';
            rowData.pso = question.programme_specific_outcome != null ? question.programme_specific_outcome.map(item => item.code).join(', ') : '';
            try {
              taxonamyScoreProductSum += Number(question.blooms_taxonamy_level) * Number(question.maximum_mark);
              taxonamyScoreSum += Number(question.maximum_mark);
            } catch (error) {
              this.questionPaperLevelCalculationFailed = true;
            }
          }
          questionPaperTableData.push(rowData);

          if (question.subQuestions.length > 0) {
            question.subQuestions.forEach(subQuestion => {
              // console.log('--');
              rowData = this.newRowDataSample();
              rowData.id = subQuestion.id;
              rowData.type = 'question';
              rowData.q_no = subQuestion.question_no;
              rowData.question = subQuestion.question;
              rowData.mark = subQuestion.maximum_mark;
              rowData.co = subQuestion.course_outcome != null ? subQuestion.course_outcome.map(item => item.code).join(', ') : '';
              rowData.co_mapping = subQuestion.course_outcome.map(co => co.id),
              rowData.module = this.moduleName(subQuestion.module_id);
              rowData.taxonamy = subQuestion.blooms_taxonamy_level;
              rowData.po = subQuestion.programme_outcome != null ? subQuestion.programme_outcome.map(item => item.code).join(', ') : '';
              rowData.pso = subQuestion.programme_specific_outcome != null ? subQuestion.programme_specific_outcome.map(item => item.code).join(', ') : '';
              questionPaperTableData.push(rowData);
              try {
                taxonamyScoreProductSum += Number(subQuestion.blooms_taxonamy_level) * Number(subQuestion.maximum_mark);
                taxonamyScoreSum += Number(subQuestion.maximum_mark);
              } catch (error) {
                this.questionPaperLevelCalculationFailed = true;
              }
            });
          }

        }
        if (ViewElement.type == 'section') {
          rowData = this.newRowDataSample();
          rowData.id = ViewElement.id;
          rowData.type = 'section';
          rowData.colspan = tempCustomHeaderCount + 3;
          rowData.text = sectionObjects[ViewElement.id].name;
          questionPaperTableData.push(rowData);
        }
      });
      this.footerQuestionPaperLevel = !this.questionPaperLevelCalculationFailed && taxonamyScoreProductSum > 0 && taxonamyScoreSum > 0;
      this.taxonamyScoreProductSum = taxonamyScoreProductSum;
      this.taxonamyScoreSum = taxonamyScoreSum;
      // console.log('- completed');
      return questionPaperTableData;
    },
    newRowDataSample() {
      return {
        id: null,
        type: null, //orGroup,orGroupQuestionSeparation,section,question
        colspan: null,
        text: null,
        q_no: null,
        question: null,
        mark: null,
        co: null,
        module: null,
        taxonamy: null,
        po: null,
        pso: null
      }
    },
    latexCodeToMathLive(codeText) {
      if (codeText == null || codeText == '') return '';
      return codeText.replace(/\$\$(.*?)\$\$/g, '<math-field class="p-0" style="border: none;" readonly>$1</math-field>');
    },
    async getExamQuestionPaperFooter() {
      const url =
        this.$store.getters.getAPIKey.examination +
        `/${this.exam.id}/questionpaper/footer`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.footerData = response.data;
        })
        .catch((error) => {
          error;
        });
    },
    
    async prepareMarkDistributionGraph() {
      this.resetDistributionData();

      if (this.examSettings.taxonamyAndCoScoreDistribution === 'equation2') {
        await this.fetchAndProcessEquation2Data();
      } else if (this.examSettings.taxonamyAndCoScoreDistribution === 'equation1') {
        this.computeEquation1Distributions();
      }

      this.$forceUpdate();
      this.generateScoreDistributionCharts();
    },

    resetDistributionData() {
      this.taxonamyScoreDistribution = {};
      this.taxonamyScoreDistributionSum = 0;
      this.coScoreDistribution = {};
      this.orquestiongroups = {};
      this.orGroupQuestionIds = {};
      this.questions = [];
      this.subQuestionParentIds = [];
    },

    computeEquation1Distributions() {
      this.taxonamyScoreDistribution = this.questionPaperTableData.reduce((scoreMap, question) => {
        if (question.taxonamy && question.mark) {
          scoreMap[question.taxonamy] = (scoreMap[question.taxonamy] || 0) + parseFloat(question.mark);
        }
        return scoreMap;
      }, {});

      this.taxonamyScoreDistributionSum = Object.values(this.taxonamyScoreDistribution).reduce((sum, value) => sum + value, 0);

      this.coScoreDistribution = this.questionPaperTableData.reduce((scoreMap, question) => {
        if (question.co_mapping && question.mark) {
          question.co_mapping.forEach(mappedCo => {
            scoreMap[mappedCo] = (scoreMap[mappedCo] || 0) + parseFloat(question.mark);
          });
        }
        return scoreMap;
      }, {});
    },

    async fetchAndProcessEquation2Data() {
      const orQuestionGroupsUrl = `${this.$store.getters.getAPIKey.mainAPI}/examorquestiongroups?exam_id=${this.exam.id}`;
      const orquestiongroups = await this.$axios.get(orQuestionGroupsUrl).then(res => res.data);

      orquestiongroups.forEach(group => {
        this.orGroupQuestionIds[group.id] = [];
        this.orquestiongroups[group.id] = group;
      });

      const questionsUrl = `${this.$store.getters.getAPIKey.examination}/${this.exam.id}/examquestions`;
      const questionsResponse = await this.$axios.get(questionsUrl).then(res => res.data);

      this.subQuestionParentIds = [...new Set(questionsResponse.map(q => q.subquestion_parent_id).filter(Boolean))];

      this.questions = questionsResponse.map(question => ({
        id: question.id,
        maximum_mark: question.maximum_mark,
        co_mapping: question.course_outcome.map(co => co.id),
        taxonamy: question.blooms_taxonamy_level,
        orquestion_group_id: question.orquestion_group_id,
        subquestion_parent_id: question.subquestion_parent_id
      }));

      await this.calculateQuestionScoreDistributions();
    },

    async calculateQuestionScoreDistributions() {
      const newTaxonamyDistribution = {};
      const newCoDistribution = {};
      this.taxonamyScoreDistributionSum = 0;
      let processedOrGroups = new Set();

      for (const question of this.questions) {
        if (question.subquestion_parent_id !== null) continue;

        if (!question.orquestion_group_id) {
          if (this.subQuestionParentIds.includes(question.id)) {
            this.questions
              .filter(q => q.subquestion_parent_id == question.id)
              .forEach(subq => {
                this.updateTaxonomyScore(newTaxonamyDistribution, subq);
                this.updateCoScore(newCoDistribution, subq);
              });
          } else {
            this.updateTaxonomyScore(newTaxonamyDistribution, question);
            this.updateCoScore(newCoDistribution, question);
          }
        } else if (!processedOrGroups.has(question.orquestion_group_id)) {
          processedOrGroups.add(question.orquestion_group_id);
          let totalScore = 0;
          let groupTaxonomy = null;
          let groupCoMapping = [];

          if (this.subQuestionParentIds.includes(question.id)) {
            this.questions
              .filter(q => q.subquestion_parent_id == question.id)
              .forEach(subq => {
                groupTaxonomy = subq.taxonamy;
                groupCoMapping = subq.co_mapping;
                totalScore += Number(subq.maximum_mark);
              });
          } else {
            groupTaxonomy = question.taxonamy;
            groupCoMapping = question.co_mapping;
            totalScore = Number(question.maximum_mark);
          }

          totalScore *= Number(this.orquestiongroups[question.orquestion_group_id].best_of_questions);

          this.updateTaxonomyScore(newTaxonamyDistribution, { taxonamy: groupTaxonomy, maximum_mark: totalScore });
          this.updateCoScore(newCoDistribution, { co_mapping: groupCoMapping, maximum_mark: totalScore });
        }
      }

      this.taxonamyScoreDistribution = { ...newTaxonamyDistribution };
      this.coScoreDistribution = { ...newCoDistribution };
    },

    updateTaxonomyScore(newTaxonamyDistribution, question) {
      if (!question.taxonamy || !question.maximum_mark) return;
      const mark = parseFloat(question.maximum_mark);
      newTaxonamyDistribution[question.taxonamy] = (newTaxonamyDistribution[question.taxonamy] || 0) + mark;
      this.taxonamyScoreDistributionSum += mark;
    },

    updateCoScore(newCoDistribution, question) {
      if (!question.co_mapping.length || !question.maximum_mark) return;
      const mark = parseFloat(question.maximum_mark);
      question.co_mapping.forEach(mappedCo => {
        newCoDistribution[mappedCo] = (newCoDistribution[mappedCo] || 0) + mark;
      });
    },

    generateScoreDistributionCharts() {
      this.coScoreDistributionChartData.labels = [];
      this.coScoreDistributionChartData.datasets[0].data = [];
      Object.values(this.courseOutcomes).forEach(co => {
        if (co.id in this.coScoreDistribution) {
          this.coScoreDistributionChartData.labels.push(co.code);
          this.coScoreDistributionChartData.datasets[0].data.push(this.coScoreDistribution[co.id]);
        }
      });

      this.taxonamyScoreDistributionChartData.labels = [];
      this.taxonamyScoreDistributionChartData.datasets[0].data = [];
      this.bloomTaxonomyOptions.forEach(tax => {
        if (tax.value in this.taxonamyScoreDistribution) {
          this.taxonamyScoreDistributionChartData.labels.push('L' + tax.value + '(' + this.taxonamyScoreDistribution[tax.value] + ')');
          this.taxonamyScoreDistributionChartData.datasets[0].data.push(this.taxonamyScoreDistribution[tax.value]);
        }
      });
    },
    // questionAttachmentDetails(attachmentId, question) {
    //   // console.log(question);
    //   return question.files.find(item => item.id == attachmentId);
    // },
    moduleName(id) {
      let module = this.courseModules.find(item => item.id === id);
      if (module) return module.module;
      return id;
    },
    async getCourseModules() {
      let courseModuleUrl = this.$store.getters.getAPIKey.getCourseModules;
      const url = courseModuleUrl.replace("course_id", this.exam.course_id);
      await this.$axios.get(url).then((response) => {
        this.courseModules = response.data;
      });
    },

    async ExamQuestionPaperCustomHeader() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/exams/${this.exam.id}/questionpaper/customheader`;
      await this.$axios.get(url).then((response) => {
        this.customHeader = response.data;
      });
    },
  },
};
</script>
<style scoped>
.no-border-cell td {
  border: none;
}

.no-border-cell th {
  border: none;
}

.no-border-cell tr {
  border: none;
}
</style>
<style>
.custom-table22 {
  width: 100%;
  font-weight: initial;
}

.custom-table22 td {
  vertical-align: top !important;
  padding: 2px 1px 1px 2px;
}
</style>
<style>
.questions-container button {
  padding: 1px !important;
}

.custom-text-section {
  font-size: 12px !important; /* Smaller font size on screen */
}

.custom-text-or-question {
  font-size: 10px !important; /* Smaller font size on screen */
}

@media print {
  .no-print {
    display: none !important;
  }

  .custom-text-section {
    font-size: 18px !important;
  }

  .custom-text-or-question {
    font-size: 16px !important; /* Smaller font size on screen */
  }

  .tempInput {
    border: none;
  }

  .questionPaperPreview {
    font-size: 14pt !important;
  }

  * {
    font-size: 14pt !important;
  }
 
}

.questionPaperPreviewImg {
  max-width: 100%;
  max-height: 600px;
}

.customHeaderDiv th {
  font-size: 12pt;
  background-color: #d7dcda;
}

.customHeaderDiv .data-tbody {
  font-size: 11pt;
  /* text-align: left; */
}

/* .data-table{
            table-layout: fixed;
            width: 660pt;
        } */
.customHeaderDiv .text-center {
  text-align: center;
}

.customHeaderDiv .header-table {
  font-size: 11pt !important;
  text-align: center;
}

.customHeaderDiv .header-table strong {
  font-size: 17pt !important;
  font-weight: 800;
}

.customHeaderDiv table {
  /* text-align: left; */
  width: 100%;
  border-collapse: collapse;
}

.customHeaderDiv table,
th,
td {
  border: 1px solid #494b4d;
}

.customHeaderDiv td {
  padding-bottom: 2pt;
  padding-top: 4pt;
  padding-left: 4pt;
  padding-right: 4pt;
}

.customHeaderDiv th {
  padding-bottom: 4pt;
  padding-top: 7pt;
  padding-left: 7pt;
  padding-right: 7pt;
}

.customHeaderDiv table tr td {
  height: auto;
}

.customHeaderDiv .wordbreak {
  word-wrap: break-word;
}

.common-font {
  font-family: 'Times New Roman';
  zoom: 1.4; /* Scales the text by 1.37 times */
}
</style>
